// extracted by mini-css-extract-plugin
module.exports = {"body":"styles_body__2Ksly"};